import type { GetServerSideProps, GetStaticProps, NextPage } from "next";
import { useEffect, useState } from "react";
import VacancyContent from "../../components/VacancyContent";
import vacancies from "../../public/data/vacancies.json";
import { VacancyApi } from "../../api/api";
import { IVacancy } from "../../utils/types";

interface IVacanciesProps {
  vacancy: IVacancy;
  vacancies: Array<IVacancy>;
  current: number;
}

const Vacancies: NextPage<IVacanciesProps> = ({
  current,
  vacancies,
  vacancy,
}) => {
  return (
    <VacancyContent vacancies={vacancies} vacancy={vacancy} current={current} />
  );
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const list = await VacancyApi.getVacancyList()
  if (!list) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      current: 0,
      vacancies: list,
      vacancy: list.length === 0 ? null : list[0],
    },
  };
};

export default Vacancies;
